import PhotoSwipeLightbox from './photoswipe-lightbox.js';
const galleries = new Map();
function initialize(root = document) {
  root.querySelectorAll('.alamina-main-product-shell').forEach(shell => {
    if (galleries.has(shell)) return;
    const gallery = shell.querySelector('.gallery-popup-images');
    if (!gallery) return;
    const lightbox = new PhotoSwipeLightbox({
      gallery, children: 'a.product-single__media-zoom',
      showHideAnimationType: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'none' : 'zoom',
      bgOpacity: 1, pswpModule: () => import('./photoswipe.js')
    });
    lightbox.on('change', () => {
      shell.querySelectorAll('video').forEach(video => {
        if (!video.autoplay) video.pause();
      });
      shell.querySelectorAll('iframe').forEach(frame => {
        if (!frame.contentWindow) return;
        let origin;
        try { origin = new URL(frame.src).origin; } catch { return; }
        if (origin === 'https://player.vimeo.com') {
          frame.contentWindow.postMessage('{"method":"pause"}', origin);
        } else if (origin === 'https://www.youtube.com' || origin === 'https://www.youtube-nocookie.com') {
          frame.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', origin);
        }
      });
    });
    lightbox.init();
    galleries.set(shell, lightbox);
  });
}
initialize();
document.addEventListener('shopify:section:load', event => initialize(event.target));
document.addEventListener('shopify:section:unload', event => {
  for (const [shell, lightbox] of galleries) {
    if (event.target.contains(shell)) {
      lightbox.destroy(); galleries.delete(shell);
    }
  }
});
